module.exports = __webpack_public_path__ + "static/img/chemistry.eb01ae55.png";